export default () => {
  const searchstring = window.location.search;
  if (/[?&]disablesegment\b/i.exec(searchstring)) window.disablesegment = true;
  if (/[?&]disablelaunch\b/i.exec(searchstring)) window.disablelaunch = true;
  if (/[?&]disablegtm\b/i.exec(searchstring)) window.disablegtm = true;
};
